module.exports = __webpack_public_path__ + "img/Picture14.9fb8716f.png";